import { applyMiddleware, compose, createStore } from "redux";
import { routerMiddleware } from "react-router-redux";
import persistState, { mergePersistedState } from "redux-localstorage";
import adapter from "redux-localstorage/lib/adapters/localStorage";
import logger from "redux-logger";
import Raven from "raven-js";

import rootReducer from "./rootReducer";
import OAuth from "./middleware/OAuth";
import ApiFetch from "./middleware/ApiFetch";
import AfterFormSoftRedirects from "./middleware/AfterFormSoftRedirects";

// Start sentry.io error reporting, will not fail on empty DSN
Raven.config(process.env.REACT_APP_SENTRY_PUBLIC_DSN).install();

export default history => {
  const middleware = [
    // Libraries
    routerMiddleware(history),
    // Boilerplate middleware
    OAuth,
    ApiFetch,

    /**
     * Add additional middleware here
     */
    AfterFormSoftRedirects
  ];

  if (process.env.NODE_ENV === "development") {
    middleware.push(logger);
  }

  const reducer = compose(mergePersistedState())(rootReducer);

  const storage = adapter(window.localStorage);

  const enhancer = compose(
    applyMiddleware(...middleware),
    persistState(storage)
  );

  return createStore(reducer, enhancer);
};



// WEBPACK FOOTER //
// ./src/redux/configureStore.js